import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { Form, Col } from '_zari/core'

const GlosaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-formulariopagos-procesar', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='text-glosa' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='glosa'>
          {({ field }) => <Form.InputText {...field} id='text-glosa' disabled={fIsSubmitting} isInvalid={iTouched && iError} onKeyDown={onKeyDown} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
